import { Navigate, useLocation, useParams } from "react-router-dom";
import { Spinner } from "@/components/ui/Spinner";
import { useConnection } from "../hooks";

/**
 * /power-projects/profil/:connectionId — a ZE project addressed by its OWN id
 * (ZEShortTypeProject pk). The workspace route /power-projects/:id is keyed by the
 * przedsięwzięcie (enterprises.Project) id, so a link that only knows the profile id
 * (ARON's `ZEShortTypeProject` references) lands here and is redirected.
 *
 * An id that is not a profile is passed through as a przedsięwzięcie id: ARON stamps the
 * same entity type for connections/by-project/{project uuid}/, so both ids reach here.
 */
export function ConnectionRedirectPage() {
  const { connectionId } = useParams<{ connectionId: string }>();
  const { search } = useLocation();
  const { data, isLoading, isError } = useConnection(connectionId);

  if (isLoading)
    return (
      <div className="p-10 flex justify-center">
        <Spinner />
      </div>
    );

  const projectId = data?.project ?? (isError ? connectionId : undefined);
  return <Navigate to={projectId ? `/power-projects/${projectId}${search}` : "/power-projects"} replace />;
}
